import { ClientIdentityContext } from 'client/contexts/ClientIdentityContext'
import { useContext } from 'react'

/**
 * Provides access to values in the candidate search context.
 */
export const useIdentity = () => {
    const clientIdentityContext = useContext(ClientIdentityContext)

    if (!clientIdentityContext) {
        throw new Error('useIdentity must be used within <useIdentity>')
    }

    return clientIdentityContext
}
